import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {limitOptionsSelect} from "../helps/optionsSelect"
import {asyncCreator} from "./sliceHelper"
import {psLeakDeviceLogApi, PSLeakDeviceLogsFilterQuery} from "../api/psLeakDeviceLogApi"
import {WSPSLeakDeviceLog} from "../types/WebSocketTypes"
import {PSLeakDeviceLogResponse, PSLeakDeviceLogsResponse} from "../models/response"

export type PSLeakDeviceLogsFilter = {
    limit: number
    offset: number
} & PSLeakDeviceLogsFilterQuery

type InitialStateType = {
    psLeakDeviceLogs: null | PSLeakDeviceLogsResponse
    psLeakDeviceLog: null | PSLeakDeviceLogResponse
    filter: PSLeakDeviceLogsFilter
    ws: WSPSLeakDeviceLog | null
}

const initialState: InitialStateType = {
    psLeakDeviceLogs: null,
    psLeakDeviceLog: null,
    filter: {
        limit: limitOptionsSelect[0].value,
        offset: 0,
    },
    ws: null,
}

export const psLeakDeviceLogReducer = createSlice({
    name: 'psLeakDeviceLogReducer',
    initialState,
    reducers: {
        setPSLeakDeviceLogs(state, {payload}) {
            state.psLeakDeviceLogs = payload
        },
        setPSLeakDeviceLog(state, {payload}) {
            state.psLeakDeviceLog = payload
        },
        setPSLeakDeviceLogsFilter(state, {payload}) {
            state.filter = payload
        },
        setWSPSLeakDeviceLog(state, {payload}: PayloadAction<WSPSLeakDeviceLog | null>) {
            state.ws = payload
        },
    },
})

export const {setPSLeakDeviceLogs, setPSLeakDeviceLog, setPSLeakDeviceLogsFilter, setWSPSLeakDeviceLog} = psLeakDeviceLogReducer.actions

export default psLeakDeviceLogReducer.reducer

export const getPSLeakDeviceLogs = asyncCreator
('psLeakDeviceLogReducer/getPSLeakDeviceLogs', psLeakDeviceLogApi.getLogs, setPSLeakDeviceLogs)

export const getPSLeakDeviceLog = asyncCreator
('psLeakDeviceLogReducer/getPSLeakDeviceLog', psLeakDeviceLogApi.getLog, setPSLeakDeviceLog)
